import BaseComponent from './BaseComponent';
import noUiSlider    from 'nouislider';
import wNumb         from 'wnumb';            // Library for easy number formatting

class FilterPrice extends BaseComponent {
  constructor(componentName){
    super(componentName);

    this.options = {
      start: [0, 500],
      connect: true,
      orientation: 'vertical',
      direction: 'ltr',
      behaviour: 'tap-drag',
      tooltips: [wNumb({decimals: 0}),wNumb({decimals: 0})],
      orientation: 'horizontal',
      step: 1,
      range: {
        min: 0,
        max: 1000
      }
    };
  }

  init(component) {
    const element       = component.element;
    const range         = !!element.getAttribute('data-range') ? element.getAttribute('data-range').split('..') : null;
    const rangeSelected = !!element.getAttribute('data-range-selected') ? element.getAttribute('data-range-selected').split('..') : null;

    if(!!range) {
      this.options.range.min = Math.floor(parseInt(range[0]));
      this.options.range.max = Math.round(parseInt(range[1]));
    }

    if(!!rangeSelected) {
      this.options.start[0] = Math.floor(parseInt(rangeSelected[0]));
      this.options.start[1] = Math.round(parseInt(rangeSelected[1]));
    }

    noUiSlider.create(element, this.options);
    const v0v1Values = this.setInitialValues(component);
    this.addCustomEvents(component);
  }

  addCustomEvents(component) {
    const element = component.element;
    element.noUiSlider.on('change', (values, handler) => {
      const v0v1Values = [Math.round(parseInt(values[0])), Math.round(parseInt(values[1]))];
      window.location.replaceQueryParam('price', element.getAttribute('data-url'), `${v0v1Values[0]}..${v0v1Values[1]}`);
    });
  }

  updateRange(component, min, max) {
    const opt = this.options;
    opt.range = { min: min, max: max };
    
    const element = component.element;
    element.noUiSlider.updateOptions(
      opt, // Object
      true // Boolean 'fireSetEvent'
    );
  }

  loadRange(url, ids) {
    app.ajax.rails(url, 'POST', `ids=${ids}`);
  }

  setInitialValues(component, store = true) {
    const rawValues  = component.element.noUiSlider.get();                   // Arr of 2 decimal values as String
    const v0v1Values = [Math.round(rawValues[0]), Math.round(rawValues[1])]; // Arr of 2 Integer(rounded) numbers
    if(store) component.currentValues = v0v1Values;
    return v0v1Values;
  }
}

export default FilterPrice;
